import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISubscription } from "../../subscriptions/types";

export interface IBasketTempProfile {
  id: string;
  type: "adult" | "child" | "daily";
  profile?: any;
  filled?: boolean;
}

export interface IBasketTempItem {
  id: string | number;
  type: "family" | "gift" | "adult" | "child" | "daily";
  title: string;
  price?: number;
  profiles?: IBasketTempProfile[];
  adultsCount?: number;
  childrenCount?: number;
  totalPeople?: number;
}

export interface IBasketTempState {
  basketTemp: IBasketTempItem[];
}

const initialState: IBasketTempState = {
  basketTemp: [],
};

const basketTempSlice = createSlice({
  name: "basketTemp",
  initialState,
  reducers: {
    addToBasketTemp(state, action: PayloadAction<IBasketTempItem[]>) {
      state.basketTemp = action.payload;
    },
    clearBasketTemp(state) {
      state.basketTemp = [];
    },
  },
});

export const { addToBasketTemp, clearBasketTemp } = basketTempSlice.actions;

export default basketTempSlice.reducer;

